module.exports = __webpack_public_path__ + "img/template1.21967840.svg";